import i18next from "i18next";
import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

export const setErrorMessageAction = (
  context: Settings2FAContext,
  event: Settings2FAEvent
): Partial<Settings2FAContext> => {
  if (event.type !== "ERROR") {
    throw new Error("Invalid event type");
  }
  return {
    message: event.message ?? i18next.t("settings.twoFA.messages.error"),
    messageType: "error",
  };
};
